import { useEffect, useState, useCallback } from 'react';

export interface Remaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isPast: boolean;
}

function compute(target: Date): Remaining {
  const diff = target.getTime() - Date.now();
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isPast: true };
  }
  const seconds = Math.floor((diff / 1000) % 60);
  const minutes = Math.floor((diff / 1000 / 60) % 60);
  const hours = Math.floor((diff / 1000 / 60 / 60) % 24);
  const days = Math.floor(diff / 1000 / 60 / 60 / 24);
  return { days, hours, minutes, seconds, isPast: false };
}

export function useCountdown(target: Date): Remaining {
  const [remaining, setRemaining] = useState<Remaining>(() => compute(target));

  const recompute = useCallback(() => {
    setRemaining(compute(target));
  }, [target]);

  useEffect(() => {
    const id = window.setInterval(recompute, 1000);
    const onVisible = () => {
      if (document.visibilityState === 'visible') recompute();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [recompute]);

  return remaining;
}
